import { appConfig } from '@common/config';

export const API_DOMAIN = 'https://api-goats.plaync.com/';

export const getDefalutImgUrl = () => {
    return appConfig.wstatic + '/plaync/gameinfo/img/thumb-' + appConfig.service + '.png';
};